import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HIGHLIGHT_CLASSES = ['ring-4', 'ring-[#1e3a8a]/40', 'ring-offset-2', 'transition-all', 'duration-700'];
const MAX_WAIT_MS = 7000;
const RETRY_INTERVAL_MS = 150;

const HashScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const elementId = decodeURIComponent(location.hash.replace('#', ''));
    let highlightTimer;

    const scrollAndHighlight = (target) => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.classList.add(...HIGHLIGHT_CLASSES);
      highlightTimer = window.setTimeout(() => {
        target.classList.remove(...HIGHLIGHT_CLASSES);
      }, 1800);
    };

    const tryScrollToTarget = () => {
      const target = document.getElementById(elementId);
      if (!target) return false;
      scrollAndHighlight(target);
      return true;
    };

    // Fast path for already-rendered sections.
    if (tryScrollToTarget()) {
      return () => {
        if (highlightTimer) window.clearTimeout(highlightTimer);
      };
    }

    // Slow path for backend-rendered sections: wait until cards are rendered.
    const startedAt = Date.now();
    const intervalId = window.setInterval(() => {
      const isFound = tryScrollToTarget();
      const timedOut = Date.now() - startedAt > MAX_WAIT_MS;
      if (isFound || timedOut) {
        window.clearInterval(intervalId);
        observer.disconnect();
      }
    }, RETRY_INTERVAL_MS);

    const observer = new MutationObserver(() => {
      if (tryScrollToTarget()) {
        window.clearInterval(intervalId);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.clearInterval(intervalId);
      observer.disconnect();
      if (highlightTimer) window.clearTimeout(highlightTimer);
    };
  }, [location.pathname, location.hash]);

  return null;
};

export default HashScrollHandler;
